import { render, staticRenderFns } from "./FullscreenPrompt.vue?vue&type=template&id=35c8f097&scoped=true"
import script from "./FullscreenPrompt.vue?vue&type=script&lang=js"
export * from "./FullscreenPrompt.vue?vue&type=script&lang=js"
import style0 from "./FullscreenPrompt.vue?vue&type=style&index=0&id=35c8f097&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c8f097",
  null
  
)

export default component.exports